'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWord = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: inline-block;\n    line-height: 36px;\n    margin-left: 8px;\n'], ['\n    display: inline-block;\n    line-height: 36px;\n    margin-left: 8px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _difference_in_years = require('date-fns/difference_in_years');

var _difference_in_years2 = _interopRequireDefault(_difference_in_years);

var _experiumPlayerHelpers = require('experium-player-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AgeWrapper = _styledComponents2.default.div(_templateObject);

var getWord = exports.getWord = function getWord(value, locale) {
    return value + " " + locale[value % 100 > 4 && value % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][value % 10 < 5 ? value % 10 : 5]];
};

var getAgeWord = function getAgeWord(year) {
    var locale = ['год', 'года', 'лет'];
    return getWord(year, locale);
};

var Age = function Age(_ref) {
    var value = _ref.value;

    var ageYears = value && value.year >= 1900 && value.month >= 0 && value.day && (0, _difference_in_years2.default)(new Date(), new Date(value.year, value.month, value.day));

    return _react2.default.createElement(
        AgeWrapper,
        null,
        value && ageYears ? _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'age' }),
            ' ',
            _react2.default.createElement(
                'b',
                null,
                getAgeWord(ageYears)
            )
        ) : null
    );
};

Age.propTypes = {
    value: _propTypes2.default.object
};

exports.default = Age;